/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pink_Teary_Ocelot_ApproveInputs */

const fr_pink_teary_ocelot_approve = /** @type {(inputs: Pink_Teary_Ocelot_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur personnalisée`)
};

/**

* @param {Pink_Teary_Ocelot_ApproveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pink_teary_ocelot_approve = /** @type {((inputs?: Pink_Teary_Ocelot_ApproveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pink_Teary_Ocelot_ApproveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pink_teary_ocelot_approve(inputs)
});